import { useEffect, useState } from "react";
import { formatCountdown, msUntilMidnight } from "@/lib/time.ts";

/** Ticks down to the player's next local midnight, then fires `onZero` once. */
export function Countdown({ onZero }: { onZero?: () => void }) {
  const [ms, setMs] = useState(() => msUntilMidnight());
  useEffect(() => {
    const id = setInterval(() => {
      const left = msUntilMidnight();
      setMs(left);
      if (left > 86_390_000) onZero?.(); // just rolled past midnight
    }, 1000);
    return () => clearInterval(id);
  }, [onZero]);
  return (
    <span className="font-ui tabular-nums" role="timer" aria-label="Time until the next verse">
      {formatCountdown(ms)}
    </span>
  );
}
